<template>
  <div>
    <el-form :model="form" label-width="80px">
      <el-form-item label="菜单">
        <el-select v-model="newmenu" placeholder="请选择">
          <el-option v-for="item in menu" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-plus" circle @click="addmenu()"></el-button>
        <div class="tag">
          <el-tag
            v-for="items in form.programa"
            :key="items.title"
            closable
            @close="close(items)"
          >{{items.title}}</el-tag>
        </div>
      </el-form-item>
      <el-form-item label="友情链接">
        <div v-for="item in form.link" :key="item.id" class="link">
          <el-input v-model="item.name" placeholder="请输入公司名"></el-input>
          <el-input v-model="item.site" placeholder="请输入公司网址"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="微信">
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-success="wechat()"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <div class="wechat">
          <img :src="form.wechat.img" />
          <el-input v-model="form.wechat.name"></el-input>
          <el-input v-model="form.wechat.title"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="联系我们">
        <div v-for="item in form.relation" :key="item.id" class="relation">
          <el-upload
            class="upload-demo"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-success="relation()"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <div>
            <img :src="item.img" />
            <el-input v-model="item.content"></el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="QQ">
        <div v-for="item in form.QQ" :key="item.id" class="qq">
          <span>标题：</span>
          <el-input v-model="item.title"></el-input>
          <span>超链接地址：</span>
          <el-input v-model="item.link"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="版权信息">
        <vue-ueditor-wrap v-model="form.copymessage"></vue-ueditor-wrap>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save()">立即创建</el-button>
        <el-button @click="goback">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        programa: [
          { id: 11, title: "网站建设" },
          { id: 12, title: "微信营销" },
          { id: 13, title: "APP开发" },
          { id: 14, title: "品牌设计" },
          { id: 15, title: "智慧飞天云" }
        ],
        link: [
          { id: 1, name: "昆山网络公司", site: "www.baidu.com" },
          { id: 2, name: "沈阳网站建设", site: "www.baidu.com" },
          { id: 3, name: "长沙建站公司", site: "www.baidu.com" },
          { id: 4, name: "东莞微信开发", site: "www.baidu.com" },
          { id: 5, name: "石家庄微信营销", site: "www.baidu.com" }
        ],
        wechat: {
          img: "http://res.sjzqcrl.com/weixin.jpg",
          name: "石家庄飞天科技",
          title: "微信公众平台"
        },
        relation: [
          {
            id: 1,
            img: "http://res.sjzqcrl.com/%E7%94%B5%E8%AF%9D%20%282%29.png",
            content: "0311-85048504 / 18395603129"
          },
          {
            id: 2,
            img: "http://res.sjzqcrl.com/%E7%94%B5%E8%AF%9D%20%282%29.png",
            content: "sjzftkj@126.com"
          },
          {
            id: 3,
            img: "http://res.sjzqcrl.com/%E7%94%B5%E8%AF%9D%20%282%29.png",
            content: "河北省石家庄市长安区谈南路63号睿和中心商业写字楼1102"
          }
        ],
        QQ: [
          {
            id: 1,
            title: "点我交谈",
            link: "http://wpa.qq.com/msgrd?v=3&uin=504922487&site=qq&menu=yes"
          },
          {
            id: 2,
            title: "点我交谈",
            link: "http://wpa.qq.com/msgrd?v=3&uin=504922487&site=qq&menu=yes"
          }
        ],
        copymessage:
          "<p><span style='float:left;'>Copyright @ 石家庄飞天科技开发有限公司 版权所有 冀ICP备14015570号-5</span><span style='float:right;'><img href='http://res.sjzqcrl.com/gaico.png'>工商网监<img href='http://res.sjzqcrl.com/gaico.png'>翼公网安备 13010802000970号</span></p>"
      },
      menu: [
        { id: 1, title: "我们的服务", grade: "1" },
        { id: 11, title: "网站建设", grade: "2" },
        { id: 12, title: "微信营销", grade: "2" },
        { id: 13, title: "APP开发", grade: "2" },
        { id: 14, title: "品牌设计", grade: "2" },
        { id: 15, title: "智慧云飞天", grade: "2" },
        { id: 2, title: "飞天动态", grade: "1" },
        { id: 16, title: "飞天观点", grade: "2" },
        { id: 17, title: "知识拓展", grade: "2" },
        { id: 3, title: "成功案例", grade: "1" }
      ],
      newmenu: ""
    };
  },
  methods: {
    addmenu() {
      if (this.newmenu == "") {
        return;
      }
      for (var a = 0; a < this.form.programa.length; a++) {
        if (this.form.programa[a].id == this.newmenu) {
          this.$alert("栏目已加载，请不要重复添加", "添加失败", {
            confirmButtonText: "确定"
          });
          return;
        }
      }
      this.menu.map(item => {
        if (item.id == this.newmenu) {
          this.form.programa.splice(this.form.programa.length, 0, item);
        }
      });
    },
    close(item) {
      this.form.programa.splice(this.form.programa.indexOf(item), 1);
    },
    wechat() {},
    relation() {},
    icp() {},
    save() {},
    goback() {
      this.$router.push("/admin/index/onepage");
    }
  }
};
</script>

<style lang="less" scoped>
.tag {
  margin-top: 20px;
  span {
    margin-right: 15px;
  }
}
.link {
  margin: 10px 0;
  .el-input {
    width: 35%;
  }
}
.wechat {
  width: 40%;
  img {
    width: 20%;
    margin-top: 20px;
  }
  input {
    width: 50%;
    margin-top: 10px;
  }
}
.relation {
  width: 30%;
  background: #eee;
  display: inline-block;
  padding: 15px;
  margin-right: 10px;
  > div {
    padding: 10px;
    img {
      width: 10%;
      padding: 15px;
    }
    input {
      width: 70%;
    }
  }
}
.qq {
  .el-input {
    width: 40%;
    margin-bottom: 10px;
  }
  span {
    font-size: 16px;
  }
}
.icp {
  width: 45%;
  background: #eee;
  display: inline-block;
  padding: 15px;
  margin-right: 10px;
  > div {
    padding: 10px;
    img {
      width: 10%;
      padding: 15px;
    }
    input {
      width: 70%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/onepage/footer.vue